import React from "react";
import "./button.css";

function Button({ label, className, children, onClick, type, disabled }) {
  let buttonClass = "btn btn-block " + className;

  return (
    <>
      <button
        className={buttonClass}
        placeholder={label}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </>
  );
}

export default Button;
